import { catchError, finalize, map, tap } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { BrfTransferForm } from '../../model/Transfer/transfer-form';

@Injectable()
export class CooperativeHousingTransferFormService extends DataService<BrfTransferForm> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, BrfTransferForm, progressBar, 'brf-transfer');
  }

  get(id: string): Observable<BrfTransferForm> {
    this.progressBar.start();
    return this.client.get<BrfTransferForm>(`${this.endpoint}/${id}`).pipe(
      map(modelData => new BrfTransferForm(modelData)),
      finalize(() => this.progressBar.stop())
    );
  }

  UpdateTransfer(id: string): Observable<void> {
    return this.client.patch(`${this.endpoint}/recalculate-values/${id}`, null).pipe(
      map(res => res),
      catchError(error => {
        this.notification.showError(error);
        return [];
      })
    );
  }

  UpdateTransfers(ids: string[]): Observable<void> {
    return this.client
      .post(`${this.endpoint}/recalculate-multiple-transfer-values`, JSON.stringify(ids), {
        headers: { 'Content-Type': 'application/json' },
      })
      .pipe(
        map(res => res),
        catchError(error => {
          this.notification.showError(error);
          return [];
        })
      );
  }
}
